import { Injectable} from '@angular/core';
import { NgbDateAdapter, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

    readonly DELIMITER = '-';

    fromModel(value: any): NgbDateStruct {
        let result: NgbDateStruct = null;
        if (value) {
            let jsonData =  this.isJson(value);
            if (jsonData != null && jsonData.day && jsonData.year) {
                result = jsonData;
            } else {
                let date = value.split(this.DELIMITER);
                result = {
                    day: parseInt(date[0], 10),
                    month: parseInt(date[1], 10),
                    year: parseInt(date[2], 10)
                };
            }
        }
        return result;
    }

    toModel(date: NgbDateStruct): any {
        let result: any = null;
        if (date) {
            result = date;
        }
        return result;
    }

    isJson(item) {
        item = typeof item !== "string"? JSON.stringify(item): item;
        try {
            item = JSON.parse(item);
        } catch (e) {
            return null;
        }
        if (typeof item === "object" && item !== null) {
            return item;
        }
        return null;
    }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

    readonly DELIMITER = '-';
    public readonly monthArray = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    parse(value: string): NgbDateStruct {
        let result: NgbDateStruct = null;
        if (value) {
            let jsonData = this.isJson(value);
            if (jsonData != null && jsonData.day && jsonData.year) {
                result = jsonData;
            } else {
                let date = value.split(this.DELIMITER);
                result = {
                    day: parseInt(date[0], 10),
                    month: parseInt(date[1], 10),
                    year: parseInt(date[2], 10)
                };
            }
        }
        return result;
    }

    format(date: NgbDateStruct): string {
        let result: string = null;
        if (date) {
            result = (date.day < 10 ? "0" + date.day : date.day ) + this.DELIMITER + this.monthArray[date.month - 1] + this.DELIMITER + date.year;
        }
        return result;
    }

    isJson(item) {
        item = typeof item !== "string" ? JSON.stringify(item) : item;
        try {
            item = JSON.parse(item);
        } catch (e) {
            return null;
        }
        if (typeof item === "object" && item !== null) {
            return item;
        }
        return null;
    }
}
